import { createRouter, createWebHistory } from 'vue-router';
import routeName from './constant';
import moduleRoutes from './modules';
import stepRoutes from './modules/indexApply';
import policyTransactionsRoutes from './modulesPolicyTransactions';
import iq from './modulesPolicyTransactions/iq';
import { guideRoutes } from '@/utils/guideRoutes';
import aplCatlCode from '@/json/aplCatlCode';
import store from '@/store';
import { cloudECounterRoutes, cloudECounterReserveRoutes, beneficiaryChangeRoutes, cloudECounterApplicantChangeRoutes, cloudECounterApplicantInsuredNameChangeRoutes, cloudECounterLoanRoutes } from './modules/cloudECounter.js';
import { cloudCounterRoutes } from './modules/cloudCounter.js';

const routes = [
    {
        path: '/',
        redirect: routeName.HOME,
        component: () => import('@/components/layout/Layout.vue'),
        children: [
            {
                path: '/otwshome',
                name: 'otwshome',
                component: () => import('@/views/home/OtwsIndex.vue'),
                meta: {
                    metaTitle: '線上交易首頁',
                    hideMenu: false,
                },
            },
            {
                path: '/home',
                name: routeName.HOME,
                component: () => import('@/views/home/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '線上交易首頁',
                    hideMenu: false,
                },
            },
            {
                path: '/record',
                name: routeName.RECORD,
                component: () => import('@/views/record/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '申請紀錄',
                    hideMenu: false,
                    pageTitle: '申請紀錄',
                },
            },
            {
                path: '/policy-inv',
                name: routeName.POLICY_INVESTMENT,
                component: () => import('@/views/aplCatl640and631/policy/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '選擇保單',
                    leaveAlert: false,
                    unableBack: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.HOME, routeName.SERVICE, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE];
                    const guideRoute = guideRoutes(from, whiteList, true, aplCatlCode.POLICY);
                    next(guideRoute);
                },
            },
            {
                path: '/policy-basic',
                name: routeName.POLICY_BASIC,
                component: () => import('@/views/aplCatl640and631/policy/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '選擇保單',
                    leaveAlert: false,
                    unableBack: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.HOME, routeName.SERVICE, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE];
                    const guideRoute = guideRoutes(from, whiteList, true, aplCatlCode.POLICY);
                    next(guideRoute);
                },
            },
            {
                path: '/service',
                name: routeName.SERVICE,
                component: () => import('@/views/aplCatl640and631/service/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '變更項目列表',
                    leaveAlert: false,
                    unableBack: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.POLICY_BASIC, routeName.POLICY_INVESTMENT, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE];
                    const guideRoute = guideRoutes(from, whiteList, true, aplCatlCode.POLICY);
                    next(guideRoute);
                },
            },
            {
                path: '/add-service',
                name: routeName.ADD_SERVICE,
                component: () => import('@/views/aplCatl640and631/service/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '加入變更項目',
                    leaveAlert: true,
                    unableBack: true,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.CONFIRM_DATA];
                    const guideRoute = guideRoutes(from, whiteList, true, aplCatlCode.POLICY);
                    if (guideRoute) {
                        const resultKeys = Object.keys(store.state.services.changeItemsResult);
                        const serviceList = store.state.services.serviceList;
                        let hasData = true;
                        serviceList.forEach(i => {
                            const list = resultKeys.find(j => j === i.transactionItemNo);
                            if (!list) {
                                hasData = false;
                            }
                        });
                        if (!hasData) {
                            next({ name: routeName.HOME });
                        } else {
                            next();
                        }
                    } else {
                        next(guideRoute);
                    }
                },
            },
            {
                path: '/otp-info',
                name: routeName.CONFIRM_TEL_MAIL,
                component: () => import('@/views/aplCatl640and631/checkTelAndMail/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '確認手機及信箱',
                    leaveAlert: true,
                    pageTitle: '請確認此保單資料',
                    unableBack: true,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.SERVICE, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE, routeName.REDIRECTING_IQ];
                    const guideRoute = guideRoutes(from, whiteList, true, aplCatlCode.POLICY);
                    next(guideRoute);
                },
            },
            {
                // 從首頁進入的聯絡資料確認頁面
                path: '/contact-info',
                name: routeName.CONTACT_INFO,
                component: () => import('@/views/aplCatl640and631/checkTelAndMail/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '確認手機及信箱',
                    leaveAlert: true,
                    pageTitle: '請確認此保單資料',
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.HOME, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE];
                    const guideRoute = guideRoutes(from, whiteList, true, aplCatlCode.CONTACT);
                    next(guideRoute);
                },
            },
            {
                path: '/edit-otp-info',
                name: routeName.EDIT_TEL_MAIL,
                component: () => import('@/views/editTelAndMail/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '確認聯絡資料',
                    leaveAlert: true,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.LOAN_TERM_TWO, routeName.HOME, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE];
                    const guideRoute = guideRoutes(from, whiteList, true, [aplCatlCode.PON4300, aplCatlCode.MULTI_PAY_CHANGE, aplCatlCode.CREDIT_CARD_EXP, aplCatlCode.MULTI_ENOTIFY, aplCatlCode.CREDIT_CARD_AUTH]);
                    next(guideRoute);
                },
            },
            ...moduleRoutes,
            {
                path: '/apply',
                redirect: routeName.NOTFOUND,
                component: () => import('../components/layout/LayoutPolicyStep.vue'),
                children: [
                    {
                        path: 'refund-payment',
                        name: routeName.REFUND_PAYMENT,
                        component: () => import('@/views/refundPayment/Index.vue'),
                        meta: {
                            auth: true,
                            metaTitle: '請選擇補/退費方式',
                            leaveAlert: true,
                            pageTitle: '請選擇補/退費方式',
                            unableBack: true,
                        },
                        beforeEnter: (to, from, next) => {
                            const whiteList = [routeName.CONFIRM_DATA];
                            const guideRoute = guideRoutes(from, whiteList, false);
                            next(guideRoute);
                        },
                    },
                    {
                        path: 'confirm-data',
                        name: routeName.CONFIRM_DATA,
                        component: () => import('@/views/confirmData/Index.vue'),
                        meta: {
                            auth: true,
                            metaTitle: '確認輸入資料',
                            leaveAlert: true,
                            pageTitle: '請確認輸入的資料',
                            unableBack: true,
                        },
                        beforeEnter: (to, from, next) => {
                            if (from.meta.code || from.fullPath === '/' || from.name === routeName.ADD_SERVICE || routeName.RISK_NOTICE || from.name === routeName.REDIRECTING_IQ) {
                                next();
                            } else {
                                next({ name: routeName.HOME });
                            }
                        },
                    },
                    {
                        path: 'OTP',
                        name: routeName.OTP,
                        component: () => import('@/views/OTP/Index.vue'),
                        meta: {
                            auth: true,
                            metaTitle: '動態密碼驗證',
                            leaveAlert: true,
                            pageTitle: '請輸入動態密碼',
                            unableBack: true,
                        },
                        beforeEnter: (to, from, next) => {
                            const whiteList = [routeName.CONFIRM_DATA, routeName.REFUND_PAYMENT, routeName.LOAN_PROGRAM, routeName.LOAN_PROGRAM_DOCUMENTS, routeName.CLOUD_E_COUNTER_PERIOD];
                            const guideRoute = guideRoutes(from, whiteList, false);
                            next(guideRoute);
                        },
                    },
                    {
                        path: 'finish',
                        name: routeName.FINISH,
                        component: () => import('@/views/finish/Index.vue'),
                        meta: {
                            auth: true,
                            metaTitle: '委託受理完成',
                            leaveAlert: false,
                            pageTitle: '委託受理完成',
                            unableBack: false,
                        },
                        beforeEnter: (to, from, next) => {
                            const whiteList = [routeName.OTP, routeName.CONFIRM_DATA, routeName.AUTH_READING];
                            const guideRoute = guideRoutes(from, whiteList, false);
                            next(guideRoute);
                        },
                    },
                    ...policyTransactionsRoutes,
                    ...stepRoutes,
                ],
            },
        ],
    },
    ...cloudCounterRoutes,
    ...cloudECounterRoutes,
    ...cloudECounterReserveRoutes,
    ...beneficiaryChangeRoutes,
    ...cloudECounterApplicantChangeRoutes,
    ...cloudECounterApplicantInsuredNameChangeRoutes,
    ...cloudECounterLoanRoutes,
    {
        path: '/notify',
        component: () => import('@/components/layout/LayoutNotify.vue'),
        children: [
            {
                path: 'announcement',
                name: routeName.ANNOUNCEMENT,
                component: () => import('@/views/notifyPage/Announcement.vue'),
                meta: {
                    auth: false,
                    metaTitle: '系統公告',
                    hideMenu: false,
                    pageTitle: '系統公告',
                },
            },
            {
                path: 'logout',
                name: routeName.LOGOUT,
                component: () => import('@/views/notifyPage/Logout.vue'),
                meta: {
                    auth: false,
                    metaTitle: '登出成功',
                    hideMenu: false,
                    pageTitle: '登出成功',
                },
            },
        ],
    },
    // 手機e方便、保戶會員專區SSO轉導頁路由
    // TODO: /mobileLogin 以及 /scvLogin 之後會統合成 /ssoLogin
    {
        path: '/scvLogin',
        name: routeName.SSO_SCV,
        component: () => import('@/views/login/ssoLogin.vue'),
        alias: '/ssoLogin',
    },
    {
        path: '/mobileLogin',
        name: routeName.SSO_MOBILE,
        component: () => import('@/views/login/ssoLogin.vue'),
        alias: '/ssoLogin',
    },
    {
        path: '/ssoLogin',
        name: routeName.SSO_PAGE,
        component: () => import('@/views/login/ssoLogin.vue'),
        meta: {
            auth: false,
            metaTitle: '單一登入',
            hideMenu: false,
            pageTitle: '單一登入',
        },
    },
    {
        path: '/redirectPage',
        name: routeName.REDIRECT_PAGE,
        component: () => import('@/views/redirect/Index.vue'),
        meta: {
            auth: false,
            metaTitle: '線上交易',
            hideMenu: false,
        },
    },
    {
        path: '/redirect/account',
        name: routeName.REDIRECT_ACCOUNT,
        component: () => import('@/views/redirect/Account.vue'),
        meta: {
            auth: false,
            metaTitle: '單一登入',
            hideMenu: false,
            pageTitle: '單一登入',
        },
    },
    ...iq,
    {
        path: '/err',
        component: () => import('@/components/layout/LayoutWarning.vue'),
        children: [
            {
                path: '401',
                name: routeName.NO_AUTH,
                component: () => import('@/views/warningPage/401page.vue'),
                meta: {
                    auth: false,
                    metaTitle: '沒有權限',
                    hideMenu: false,
                    pageTitle: '沒有使用權限',
                },
            },
            {
                path: '404',
                name: routeName.NOTFOUND,
                component: () => import('@/views/warningPage/404page.vue'),
                meta: {
                    auth: false,
                    metaTitle: '找不到頁面',
                    hideMenu: false,
                    pageTitle: 'OPPS',
                },
            },
            {
                path: '403',
                name: routeName.FORBIDDEN,
                component: () => import('@/views/warningPage/403page.vue'),
                meta: {
                    auth: false,
                    metaTitle: '身分驗證失敗',
                    hideMenu: false,
                    pageTitle: '登入發生錯誤',
                },
            },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/err/404',
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: () => ({
        top: 0,
    }),
    routes
});

export default router;
